import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { forwardRef, useContext } from 'react';
import { HeaderNavigationLinkRoot } from './style';
import { useComponentTheme } from '../../../../utils/hooks';
import { HEADER_NAVIGATION_LINK_CLASS_PREFIX, headerNavigationLinkRoot } from './constants';
import { headerNavigationLink } from './theme';
import HeaderNavigationLinksContext from '../HeaderNavigationLinksContext';
import { useHeaderNavigationLinkClassName } from './utils';
import { useHeaderNavigationLink } from './utils/useHeaderNavigationLink';
export var HeaderNavigationLink = forwardRef(function HeaderNavigationLink(_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'span' : _ref$tag,
      restProps = _objectWithoutProperties(_ref, ["className", "children", "tag"]);

  var headerNavigationLinksContext = useContext(HeaderNavigationLinksContext);
  var theme = useComponentTheme(HEADER_NAVIGATION_LINK_CLASS_PREFIX, headerNavigationLink);
  var classOverride = useHeaderNavigationLinkClassName(HEADER_NAVIGATION_LINK_CLASS_PREFIX, className);

  var _useHeaderNavigationL = useHeaderNavigationLink(_objectSpread({
    headerNavigationLinksContext: headerNavigationLinksContext
  }, restProps)),
      isActive = _useHeaderNavigationL.isActive,
      onClick = _useHeaderNavigationL.onClick,
      restRootProps = _useHeaderNavigationL.restRootProps;

  return React.createElement(HeaderNavigationLinkRoot, Object.assign({
    "data-testid": headerNavigationLinkRoot
  }, restRootProps, {
    theme: theme,
    className: classOverride.Root,
    isActive: isActive,
    onClick: onClick
  }), function (forwardedProps) {
    return React.createElement(Tag, Object.assign({}, forwardedProps, {
      ref: ref
    }), children);
  });
});
HeaderNavigationLink.defaultProps = {};